import { IPermissionContentMap, PERMISSION_CONTENT_TYPE } from '../interface';
import { CoursePermissionInfo } from './course';
import { MicroPagePermissionInfo } from './microPage';
import { ProgramPermissionInfo } from './program';
import { SessionPermissionInfo } from './session';
import { EmptyPermissionInfo } from './emptyContent';
const contentPermissionMap: IPermissionContentMap = {
    [PERMISSION_CONTENT_TYPE.MICRO_PAGES]: {
        content: MicroPagePermissionInfo,
    },
    [PERMISSION_CONTENT_TYPE.COURSE]: {
        content: CoursePermissionInfo,
    },
    [PERMISSION_CONTENT_TYPE.SESSION]: {
        content: SessionPermissionInfo,
    },
    [PERMISSION_CONTENT_TYPE.PROGRAM]: {
        content: ProgramPermissionInfo,
    },
    [PERMISSION_CONTENT_TYPE.CIRCLE]: {
        content: EmptyPermissionInfo,
    },
    [PERMISSION_CONTENT_TYPE.LECTURER]: {
        content: EmptyPermissionInfo,
    },
    [PERMISSION_CONTENT_TYPE.OUTER_URL]: {
        content: EmptyPermissionInfo,
    },
};
export { contentPermissionMap };
